import './mapTouchGuard.css';

// Maps on touch screens: a long press anywhere on the map does nothing. Not the phone's own (image menu,
// text selection, its haptic tick), and a finger held on an area isn't a tap that switches the area when it
// lifts. Used by kartvy and listvy.

// A touch held longer than this isn't a tap.
const TAP_MAX_MS = 500;

// For the whole map, from the start: no phone menu or text selection on a long press (the class turns
// on user-select / touch-callout: none in mapTouchGuard.css), and a finger held longer than a tap
// doesn't click whatever is under it when it lifts. Returns a cleanup function.
export const attachMapTouchGuard = (map) => {
    const container = map.getContainer();
    container.classList.add('has-touch-guard');
    let touchStartedAt = 0;
    let touchHeldTooLong = false;
    const onPointerDown = (event) => {
        if (event.pointerType !== 'touch' || !event.isPrimary) {
            touchStartedAt = 0;
            return;
        }
        touchStartedAt = Date.now();
        touchHeldTooLong = false;
    };
    const onPointerUp = (event) => {
        if (event.pointerType === 'touch' && touchStartedAt) touchHeldTooLong = Date.now() - touchStartedAt > TAP_MAX_MS;
    };
    const onClickCapture = (event) => {
        if (!touchHeldTooLong) return;
        touchHeldTooLong = false;
        event.preventDefault();
        event.stopImmediatePropagation();
    };
    const onContextMenu = (event) => {
        if (touchStartedAt) event.preventDefault();
    };
    container.addEventListener('pointerdown', onPointerDown, true);
    window.addEventListener('pointerup', onPointerUp, true);
    container.addEventListener('click', onClickCapture, true);
    container.addEventListener('contextmenu', onContextMenu);
    return () => {
        container.classList.remove('has-touch-guard');
        container.removeEventListener('pointerdown', onPointerDown, true);
        window.removeEventListener('pointerup', onPointerUp, true);
        container.removeEventListener('click', onClickCapture, true);
        container.removeEventListener('contextmenu', onContextMenu);
    };
};
